module.exports = {
  "country": "NO",
  "artist": "Maria Haukaas Storeng",
  "song": "Hold On Be Strong",
  "year": "2008",
  "place": "5",
  "spotify": "674mIXeX6ucMlhyLWgzvdP"
};